import type { ReactNode } from "react";
import { Link } from "react-router";
import { UserDropdown } from "./UserDropdown";
import styles from "./TopNav.module.css";

interface NavItem {
  readonly href: string;
  readonly icon: ReactNode;
  readonly label: string;
}

interface TopNavProps {
  readonly navItems: readonly NavItem[];
  readonly activeHref: string;
  readonly userName: string;
  readonly onLogout: () => void;
  readonly showAdminLink?: boolean;
}

export function TopNav({ navItems, activeHref, userName, onLogout, showAdminLink }: TopNavProps) {
  return (
    <div className={styles.wrapper}>
      <header className={styles.bar}>
        <Link to="/dashboard" className={styles.logo} aria-label="TidyRota home">
          <svg
            width="26"
            height="26"
            viewBox="0 0 28 28"
            fill="none"
            aria-hidden="true"
          >
            <rect width="28" height="28" rx="6" fill="var(--color-accent-solid)" />
            <path
              d="M8 14.5L12 18.5L20 10.5"
              stroke="white"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className={styles.wordmark}>TidyRota</span>
        </Link>

        <nav className={styles.nav} aria-label="Main navigation">
          {navItems.map(({ href, icon, label }) => {
            const isActive = href === activeHref || (href !== "/dashboard" && activeHref.startsWith(href + "/"));
            return (
              <Link
                key={href}
                to={href}
                className={`${styles.navItem} ${isActive ? styles.navItemActive : ""}`}
                aria-current={isActive ? "page" : undefined}
              >
                <span className={styles.navIcon}>{icon}</span>
                <span>{label}</span>
              </Link>
            );
          })}
        </nav>

        <UserDropdown userName={userName} onLogout={onLogout} showAdminLink={showAdminLink} />
      </header>
    </div>
  );
}
